import { createGlobalState, useSessionStorage } from '@vueuse/core';
import type { ICheckLoanStatusResp, IRightItem, IRightConfig } from '@common/core/interface/IModel';
interface State {
  userStatus: ICheckLoanStatusResp;
  allTeslaRightList: IRightItem[] | [];
  allOtherRightList: IRightItem[] | [];
  curRights: IRightConfig[] | [];
  date: string[];
  detail: IRightConfig | Record<string, never>;
  allActivityNosRecord: {[key: string]: number};
  MonthActivityNosRecord: {[key: string]: number};
}

export const useGlobalState = createGlobalState(() =>
  useSessionStorage<State>('right', {
    userStatus: {
      overdue: false,
      prepay: false,
      loanAmount: 0,
      writeOff: false,
      isfirst: true,
      proNo: '',
      baseProNo: '',
    },
    curRights: [],
    allTeslaRightList: [],
    allOtherRightList: [],
    date: [],
    detail: {},
    allActivityNosRecord: {},
    MonthActivityNosRecord: {}
  }),
);
